import apiClient from './apiClient';

export interface AcceptanceProjectionIdentity {
  formId: string;
  contractHash: string;
  projectionSchemaVersion: string;
}

export const acceptanceProjectionApi = {
  async get(formId: string) {
    return (await apiClient.get<AcceptanceProjectionIdentity>(
      `/api/acceptance/projections/${encodeURIComponent(formId)}`,
    )).data;
  },
};
